module.exports = "h2 span {\n  border-bottom: solid 2px #d21f00; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modules/page-header/page-header.component.scss
// module id = ./src/app/shared/modules/page-header/page-header.component.scss
// module chunks = main